import { ApiService } from "../services/api";

/**
 * AI ÖĞRETMEN — TEK GİRİŞ NOKTASI (9 Ağu 2026)
 *
 * Uygulamada AI öğretmene giden yollar üç ayrı panele dağılmıştı: yeni AITutor,
 * eski DeficiencyTutorPanel (`ai/tutor/*`) ve eski TopicTutorPanel. Eski iki yol
 * ayrı bir motoru sürüyordu: soru ÜRETİYOR (havuz kararına aykırı), kazanımı farklı
 * eşikle (min(3, %60)) kapatıyor, `ai_teacher_logs`'a ve öğrenme defterine hiçbir
 * kayıt yazmıyordu — yani sahada olan biteni göremiyorduk.
 *
 * Artık eksikten AI öğretmene giden HER düğme buradan geçer. Plan/materyal/soru
 * kurulumunu sunucu yapar (`teach/start`): eksikten girildiğinde plan, o föydeki
 * TÜM açık eksikleri kapsar — istenen kazanım önce, kalanlar föy sırasıyla.
 */

export type AITeacherFallbackContext = Record<string, any>;

export interface OpenAITeacherOptions {
  /** Föyde kapatılacak eksik kalmadıysa panel açılmaz; sunucunun mesajı buradan gösterilir. */
  onCompleted?: (message: string) => void;
}

/**
 * Eksik kazanımdan AI Öğretmen panelini açar.
 *
 * @param gainId  UserGain (`ugain_`) ya da içerik kazanımı (`lscontent_`) kimliği.
 * @param fallbackContext Sunucu kurulumu başarısız olursa kullanılacak yerel context.
 *                        Plansız/geçmişsiz olur ama panel yine de açılır — öğrenciyi
 *                        boş ekranda bırakmamak için.
 * @returns Sunucu planı kurulabildiyse true.
 */
export const openAITeacherForGain = async (
  gainId: string,
  fallbackContext: AITeacherFallbackContext = {},
  options: OpenAITeacherOptions = {},
): Promise<boolean> => {
  const dispatch = (context: AITeacherFallbackContext) => {
    window.dispatchEvent(new CustomEvent("toggleAITutorPanel", { detail: { context } }));
  };

  if (!gainId) {
    dispatch(fallbackContext);
    return false;
  }

  try {
    const session = await ApiService.startTeach({ gainId });
    // Eksik bu arada kapanmışsa (liste eskiydi) aynı kazanımı yeniden anlatmak yerine panel açılmaz,
    // liste tazelenir ve öğrenciye neden açılmadığı söylenir.
    if (session.completed) {
      window.dispatchEvent(new CustomEvent("aiTeacherGainResolved", { detail: { gainId, resolvedCount: 0 } }));
      options.onCompleted?.(session.message || "Bu konudaki eksiklerin kapanmış.");
      return true;
    }
    dispatch(session.aiContext);
    return true;
  } catch (error) {
    console.warn(
      "[ai-ogretmen] teach/start başarısız, yerel context ile açılıyor:",
      (error as any)?.message,
    );
    dispatch(fallbackContext);
    return false;
  }
};
